<template><div><h1 id="artikelliste-nach-monaten-export-fur-excel" tabindex="-1"><a class="header-anchor" href="#artikelliste-nach-monaten-export-fur-excel"><span>Artikelliste nach Monaten, Export für Excel</span></a></h1>
<p>Artikelliste nach Monaten, Export für Excel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Datei im Excelformat für die gewünschten Artikel. Sie dient der Überprüfung aller relevanten Daten aus dem Artikelstamm und dem Einkauf. Die Statistik gruppiert den Output nach Artikeltypen (N, A, F) und kumuliert die Werte nach den gewünschten Monaten. Zusätzlich können nach bis zu 4 Artikelmerkmalen einzelne Artikel separat ausgewiesen werden.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Artikelliste nach Monaten, Export für Excel</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>ArtGruppe</dt>
<dd>Artikelgruppe, leer = alle</dd>
<dt>PM</dt>
<dd>Produkt Manager, leer = alle</dd>
<dt>von Monat,Jahr</dt>
<dd>Monat, Jahr, inklusive</dd>
<dt>bis Monat,Jahr</dt>
<dd>Monat, Jahr, inklusive</dd>
<dt>Merkmale separat</dt>
<dd>ja = Artikel mit diesem Merkmal erscheint in einer eigenen Kolonne. Maximal 4 Merkmale können so separat ausgewiesen werden</dd>
<dt>Ausgabe</dt>
<dd>Standard (Textdatei)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ArtNum</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Typ</td>
<td>Artikeltyp, fix vorgegeben im Programm (N = normale Artikel; A = assemblierte Artikel; F = fiktive Artikel, Dienstleistungen)</td>
</tr>
<tr>
<td>Bezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>ArtGrp</td>
<td>Artikelgruppe</td>
</tr>
<tr>
<td>PM</td>
<td>Produkt Manager</td>
</tr>
<tr>
<td>EkPreis</td>
<td>Einkaufspreis</td>
</tr>
<tr>
<td>VkPreis</td>
<td>Verkaufspreis</td>
</tr>
<tr>
<td>MWSt-Code</td>
<td>MWST-Code</td>
</tr>
<tr>
<td>Satz</td>
<td>%-Satz MWST gemäss Code</td>
</tr>
<tr>
<td>LgBest.-[Datum]</td>
<td>Gesamtbestand in allen Lagern per [Datum]</td>
</tr>
<tr>
<td>Lagerbestand</td>
<td>Lagerbestand pro einzelnes Lager</td>
</tr>
<tr>
<td>VKBest.-[Datum]</td>
<td>verkaufbarer Bestand in allen Lagern per [Datum]</td>
</tr>
<tr>
<td>Reserv.</td>
<td>reservierte Menge aus Aufträgen</td>
</tr>
<tr>
<td>Vorres.</td>
<td>vorreservierte Menge aus Aufträgen</td>
</tr>
<tr>
<td>Bestellt</td>
<td>bestellte, noch nicht gelieferte Menge</td>
</tr>
<tr>
<td>Neuer VP</td>
<td>neuer Verkaufpreis</td>
</tr>
<tr>
<td>ab Datum</td>
<td>neuer Verkaufpreis ab Datum</td>
</tr>
<tr>
<td>Warnmenge</td>
<td>bei Eingabe dieser Verkaufsmenge im Auftrag soll eine Warnung erscheinen</td>
</tr>
<tr>
<td>Grenzbest</td>
<td>Artikel-Grenzbestand</td>
</tr>
<tr>
<td>BestellPt.</td>
<td>Minimalbestand (Bestellpunkt)</td>
</tr>
<tr>
<td>AufKto</td>
<td>Aufwands-Konto</td>
</tr>
<tr>
<td>AufKst</td>
<td>Aufwands-Kostenstelle</td>
</tr>
<tr>
<td>ErtKto</td>
<td>Ertrags-Konto</td>
</tr>
<tr>
<td>ErtKst</td>
<td>Ertrags-Kostenstelle</td>
</tr>
<tr>
<td>Stat</td>
<td>Status (A = Auslaufartikel, M= momentan nicht verfügbar)</td>
</tr>
<tr>
<td>Ereig</td>
<td>Ereignisnummer</td>
</tr>
<tr>
<td>Merkmale</td>
<td>alle Merkmale</td>
</tr>
<tr>
<td>M1 M2 M3 M4</td>
<td>Sondermerkmale separat, maximal 4 Artikelmerkmale</td>
</tr>
<tr>
<td>EK[Monat]</td>
<td>Einkaufsmenge pro [Monat]</td>
</tr>
<tr>
<td>Wert</td>
<td>Einkaufswert pro [Monat]</td>
</tr>
<tr>
<td>VL[Monat]</td>
<td>Verkaufsmenge an Wiederverkäufer pro [Monat]</td>
</tr>
<tr>
<td>Wert</td>
<td>Verkaufswert an Wiederverkäufer pro [Monat]</td>
</tr>
<tr>
<td>VT[Monat]</td>
<td>Verkaufsmenge &quot;normale&quot; Kundenaufträge pro [Monat]</td>
</tr>
<tr>
<td>Wert</td>
<td>Verkaufswert &quot;normale&quot; Kundenaufträge pro [Monat]</td>
</tr>
<tr>
<td>EK-D</td>
<td>Einkaufsmenge Total</td>
</tr>
<tr>
<td>Wert</td>
<td>Einkaufswert Total</td>
</tr>
<tr>
<td>VK-D</td>
<td>Verkaufsmenge Total (= [VL[Monat]] + [VT[Monat]])</td>
</tr>
<tr>
<td>Wert</td>
<td>Verkaufswert Total (= [Wert VL] + [Wert VT])</td>
</tr>
</tbody>
</table>
<p>ArtNum  Typ     Bezeichnung     ArtGrp  PM      EkPreis VkPreis MWSt-Code       Satz    LgBest.-05.03.99        Lagerbestand im 0       Lagerbestand im 11      Lagerbestand im 12      Lagerbestand im 13      Lagerbestand im 15      Lagerbestand im 19      Lagerbestand im 21      Lagerbestand im 23      Lagerbestand im 115     Lagerbestand im 118     Lagerbestand im 198     Lagerbestand im 438     Lagerbestand im 514     Lagerbestand im 531     Lagerbestand im 20518   Lagerbestand im 335673  Lagerbestand im 336806  Lagerbestand im 439283  Lagerbestand im 1042636 Lagerbestand im 1042823 Lagerbestand im 1078685 Lagerbestand im 3336806 Lagerbestand im 3344061 Lagerbestand im 3356227 Lagerbestand im 3356873 Lagerbestand im 3371916 Lagerbestand im 3399963 Lagerbestand im 3410031 Lagerbestand im 3451353 Lagerbestand im 3480147 Lagerbestand im 3480380 Lagerbestand im 3502440 Lagerbestand im 3504868 Lagerbestand im 3546361 VKBest.-05.03.99        Reserv. Vorres. Bestellt        Neuer VP        ab Datum        Warnmenge       Grenzbest       BestellPt.      AufKto  AufKst  ErtKto  ErtKst  Stat    Ereig   Merkmale        M1      M2      M3      M4      EK  3-1997      Wert    VL  3-1997      Wert    VT  3-1997      Wert    EK-D- 3-1997- 3-1997    Wert    VT-D- 3-1997- 3-1997    Wert
0001.00 N       Solar-Armbanduhr 'Solar 1', grau        93310   rh      92.21   128.00  1       6.5     0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0.00            0       0       0       3000    45200   6100    45200   A       0       avis,dlog,fk3,hk3,hk4,k2/3,p295,rück,                                   0.00    0.00    0.00    0.00    0.00    0.00    0.00    0.00    0.00    0.00
0001.01 N       Ersatzuhrenband grau zu'Solar 1'        100     rh      8.72    19.00   1       6.5     0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0       0.00            0       0       0       3000    45200   6100    45200           0       ersa,                                   0.00    0.00    0.00    0.00    0.00    0.00    0.00    0.00    0.00    0.00
0002.00 N       Gutschein Fr. 100.--    100     jab     0.00    100.00  1       6.5.</p>
<p>Lesebeispiel: Der Artikel 0001.01 &quot;Ersatzuhrenband grau zu Solar1&quot; weist folgende Eigenschaften auf: es ist ein Normalartikel, Artikelgruppe 100, Produktmanager &quot;rh&quot;, Einkaufspreis Fr. 8.72, Verkaufspreis Fr. 19.--, Mehrwertsteuercode 1, 6,5 %, Lagerbestand per Auswertungsdatum 0 Stück, etc. etc.</p>
</div></template>


